import { render } from "./com_compras.vue?vue&type=template&id=638cec78&scoped=true"
import script from "./com_compras.vue?vue&type=script&lang=js"
export * from "./com_compras.vue?vue&type=script&lang=js"

import "./com_compras.vue?vue&type=style&index=0&id=638cec78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638cec78"]])

export default __exports__